import { render, staticRenderFns } from "./UpdateAssetDetails.vue?vue&type=template&id=c4ebe8ba"
import script from "./UpdateAssetDetails.vue?vue&type=script&lang=js"
export * from "./UpdateAssetDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports